import * as React from "react";

function MachineLearningIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enable-background="new 0 0 100 100"
      viewBox="0 0 100 100"
	  stroke="#002E3A"
      {...props}
    >
      <path
        d="M38.06,44.5h-2.22c-3.46,0-6.28,2.47-6.28,5.5c0,0.83-0.67,1.5-1.5,1.5s-1.5-0.67-1.5-1.5c0-4.69,4.16-8.5,9.28-8.5h2.22
	c2.24,0,4.06-1.57,4.06-3.5c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C45.11,41.58,41.95,44.5,38.06,44.5z M84.5,45.5
	c-1.95,0-3.6,1.26-4.22,3H62.5c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5h17.78c0.62,1.74,2.27,3,4.22,3c2.48,0,4.5-2.02,4.5-4.5
	S86.98,45.5,84.5,45.5z M78.5,63.5c-1.95,0-3.6,1.26-4.22,3h-3.16l-7.56-7.56c-0.28-0.28-0.66-0.44-1.06-0.44h-4
	c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5h3.38l7.56,7.56c0.28,0.28,0.66,0.44,1.06,0.44h3.78c0.62,1.74,2.27,3,4.22,3
	c2.48,0,4.5-2.02,4.5-4.5S80.98,63.5,78.5,63.5z M70.5,30.5c-0.4,0-0.78,0.16-1.06,0.44l-7.56,7.56H58.5c-0.83,0-1.5,0.67-1.5,1.5
	s0.67,1.5,1.5,1.5h4c0.4,0,0.78-0.16,1.06-0.44l7.56-7.56h3.16c0.62,1.74,2.27,3,4.22,3c2.48,0,4.5-2.02,4.5-4.5s-2.02-4.5-4.5-4.5
	c-1.95,0-3.6,1.26-4.22,3H70.5z M71,82c0,2.48-2.02,4.5-4.5,4.5S62,84.48,62,82c0-1.05,0.38-2.01,0.98-2.77l-5.28-7.73H54V80
	c0,5.15-3.79,9.7-9.22,11.07c-1.08,0.28-2.22,0.43-3.39,0.43c-6.95,0-12.61-5.16-12.61-11.5c0-0.19,0.01-0.39,0.02-0.58
	C22.54,78.75,17.67,73.88,17.67,68c0-1.18,0.19-2.32,0.57-3.41C13.62,60.88,11,55.62,11,50c0-7.24,4.44-13.87,11.42-17.22
	c-0.21-0.9-0.31-1.83-0.31-2.78c0-6.25,4.63-11.59,11.18-13.08c0.59-4.73,4.99-8.42,10.32-8.42c1.19,0,2.36,0.19,3.49,0.55
	C51.22,10.38,54,13.98,54,18v10.5h3.71l5.28-7.73C62.38,20.01,62,19.05,62,18c0-2.48,2.02-4.5,4.5-4.5S71,15.52,71,18
	s-2.02,4.5-4.5,4.5c-0.34,0-0.67-0.04-0.98-0.12l-5.78,8.46C59.46,31.26,59,31.5,58.5,31.5H54v22.48c0,0,0,0,0,0V68.5h4.5
	c0.5,0,0.96,0.24,1.24,0.65l5.78,8.46c0.32-0.07,0.64-0.12,0.98-0.12C68.98,77.5,71,79.52,71,82z M51,80v-4.69
	c-1.15,0.75-2.55,1.19-4.06,1.19c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5c2.24,0,4.06-1.57,4.06-3.5V58.04
	c-1.2,0.81-2.61,1.33-4.1,1.44c-0.19,0.01-0.39,0.02-0.58,0.02c-0.08,0-0.16-0.01-0.23-0.02c-3.38,0.81-5.1,2.56-5.1,5.21
	c0,0.83-0.67,1.5-1.5,1.5s-1.5-0.67-1.5-1.5c0-2.85,1.27-5.11,3.65-6.61c-0.98-0.64-1.82-1.46-2.41-2.44
	c-0.43-0.71-0.21-1.63,0.5-2.06c0.71-0.43,1.63-0.21,2.06,0.5c0.95,1.56,2.96,2.55,4.9,2.41c1.84-0.13,3.57-1.29,4.31-2.83V31.39
	c-3.89-0.5-7.88-2.89-8.85-7.05c-0.19-0.81,0.31-1.61,1.12-1.8c0.81-0.19,1.61,0.31,1.8,1.12c0.68,2.9,3.53,4.29,5.93,4.7V18
	c0-2.71-1.94-5.16-4.83-6.09c-0.32-0.1-0.65-0.17-0.98-0.24c-2.4,1.35-3.93,3.72-3.93,6.33v0.17c0,0.25-0.18,0.46-0.43,0.49
	C34.64,19.6,30.15,24.36,30.15,30c0,1.2,0.2,2.36,0.59,3.45c0.09,0.25-0.03,0.53-0.28,0.63C23.52,36.91,19.04,43.16,19.04,50
	c0,5.35,2.68,10.34,7.34,13.68c0.2,0.14,0.26,0.4,0.16,0.62c-0.56,1.15-0.84,2.4-0.84,3.69c0,5.24,4.76,9.5,10.61,9.5h0.23
	c0.15,0,0.3,0.07,0.39,0.19c0.1,0.12,0.13,0.28,0.1,0.42c-0.14,0.61-0.22,1.25-0.22,1.89c0,3.58,2.28,6.82,5.75,8.43
	c0.5-0.05,1-0.13,1.47-0.26C48.14,87.13,51,83.77,51,80z"
      ></path>
    </svg>
  );
}

export default MachineLearningIcon;
